import React, { useEffect, useState } from "react";
import { getOrder } from "../services/adminDataService";
import { getAddressLabel, getUserLabel } from "../utils/orderDisplay";

const valueOrDash = (value) => value === undefined || value === null || value === "" ? "—" : value;
const firstValue = (...values) => values.find((value) => value !== undefined && value !== null && String(value).trim() !== "");
const phoneFrom = (person) => {
  const source = person || {};
  return firstValue(
  source.phoneNumber,
  source.phone_number,
  source.patientPhone,
  source.phone,
  source.phoneNo,
  source.mobile,
  source.mobileNumber,
  source.mobile_number,
  source.contactNumber,
  source.contactPhone,
  source.telephone,
  source.contact?.phone,
  source.contact?.phoneNumber,
);
};

const DeliveryLabelModal = ({ show, item, onClose }) => {
  const [order, setOrder] = useState(item);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !item?.id) return undefined;
    let active = true;
    setOrder(item);
    setLoading(true);
    getOrder(item.id).then((detail) => { if (active) setOrder(detail); }).catch(() => {}).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [show, item]);

  if (!show || !item) return null;
  const patient = order?.patient || order?.beneficiary || order?.user || order?.customer || order?.client || order?.ownerUser || {};
  const phone = firstValue(
    phoneFrom(order),
    ...[order?.patient, order?.beneficiary, order?.user, order?.customer, order?.client, order?.ownerUser, order?.patientDetails, order?.userDetails].map(phoneFrom),
  );
  const patientId = firstValue(order?.teoudatZehoutId, order?.teudatZehut, order?.identityNumber, patient.teoudatZehoutId, patient.teudatZehut, patient.identityNumber);

  return <>
    <div className="modal show delivery-label-modal" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-modal="true" aria-label={`Delivery label for order ${order?.id || item.id}`} onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <div className="modal-dialog modal-dialog-centered modal-lg delivery-label-dialog"><div className="modal-content">
        <div className="delivery-label-controls"><button type="button" onClick={() => window.print()}><i className="bi bi-printer"/> Print delivery label</button><button type="button" onClick={onClose} aria-label="Close"><i className="bi bi-x-lg"/></button></div>
        <article className="delivery-label-printable">
          <header className="delivery-label-brand"><img src="/assets/img/kare-logo.png" alt="Kare"/><div><b>KARE PHARMACY</b><span>Tel Aviv-Yafo, Israel</span><span>contact@kare-pharm.com</span></div></header>
          <div className="delivery-label-rule"/>
          {loading ? <p className="delivery-label-loading">Loading delivery details…</p> : <section className="delivery-label-patient"><div><span>Patient name</span><strong>{getUserLabel(order)}</strong></div><div><span>ID number (optional)</span><strong>{valueOrDash(patientId)}</strong></div><div><span>Phone number</span><strong>{valueOrDash(phone)}</strong></div><div className="delivery-label-address"><span>Delivery address</span><strong>{getAddressLabel(order)}</strong></div></section>}
        </article>
      </div></div>
    </div>
    <div className="modal-backdrop fade show delivery-label-backdrop" onClick={onClose}/>
  </>;
};

export default DeliveryLabelModal;
